import {Component, ComponentFactoryResolver, Input, OnInit} from '@angular/core';
import {ModelComponents} from "../../../model/modelComponents";
import {NavController} from "@ionic/angular";
import {NavigationExtras} from "@angular/router";
import {MainService} from "../../../services/MainService";
import {ModelToolsProvider} from "../../../../framework/providers/model-tools/model-tools";
import {Address} from "../../../../framework/model/core/address/address";
import {AppDataService} from "../../../services/AppDataService";

@Component({
    selector: 'adv-slider',
    templateUrl: './adv-slider.component.html',
    styleUrls: ['./adv-slider.component.scss'],
})
export class AdvSliderComponent implements OnInit {

    @Input()
    public modelName: string = 'mainadvertise';

    @Input()
    public filters: object = {};

    @Input()
    public options: object = {};

    @Input()
    public slidesPerView: number = 1;

    @Input()
    public style: object = {'width': '100%'};

    @Input()
    public height: number = 200;
    // public height:number = 200;

    @Input()
    public margin: number = 0;

    @Input()
    public background: boolean = true;

    @Input()
    public autoplay: boolean = false;

    @Input()
    public appDataKey: string;

    @Input()
    public dataModels: Array<any>;

    public models: Array<any> = [];
    public afterRandom: boolean = false;

    public ready: boolean = false;

    @Input()
    public closeable: boolean = false;

    @Input()
    public prefix = 'advSlider_' + +Math.floor(Math.random() * Math.floor(1000000));

    constructor(public modelComponents: ModelComponents, private navCtrl: NavController, public appDataService: AppDataService,
                public mainService: MainService, public modelTools: ModelToolsProvider) {

    }

    ngOnInit() {
        if (!this.options['prefix'])
            this.options['prefix'] = this.prefix;
        this.options['autoplay'] = this.autoplay;

        if (!this.mainService.sliderAutoPlay) {

            this.options['autoplay'] = false;
        }

        // //console.log'autoplay adv slider!!!!! ********************************');

        this.options['slidesPerView'] = this.slidesPerView;

        if (this.dataModels) {
            for (let k in this.dataModels) {
                this.models.push(this.appDataService.getModelData(this.dataModels[k], 'address'))
            }

            let me = this;
            setTimeout(function () {
                me.ready = true;
            }, 500)
        } else {
            this.ready = true;
        }

    }

    openAdv(adv) {
        if (adv.data.page) {
            if (adv.data.page == 'none')
                return;

            if (adv.data.page == 'register') {
                this.mainService.goToRegister();
                return
            }

            this.goTo(adv.data.page, {});
            return
        }

        if (adv.data.itemId) {
            this.goTo('item/' + adv.data.itemId, {});
            return
        }

        if (adv.data.sectionId) {
            this.goTo('section/' + adv.data.sectionId, {});
            return
        }

        this.goTo('sales', {});
    }

    goTo(page, params) {
        // let navigationExtras: NavigationExtras = {
        //     queryParams: params
        // };
        //
        // this.navCtrl.navigateForward(page, navigationExtras)
        this.modelTools.goTo(page, params);
    }

    //make the first slide to be randomized
    getRandom(models) {
        if (!this.models || this.models.length == 0) return [];
        if (this.afterRandom) return this.models;
        this.afterRandom = true;
        this.models.unshift(this.models[Math.floor(Math.random() * (this.models.length - 1))]);
        return this.models;

    }
}
